import {
  ACTION_LOAD_SITE_STATIC_PAGES__REQUEST,
  ACTION_LOAD_SITE_STATIC_PAGES__SUCCESS,
  ACTION_LOAD_SITE_STATIC_PAGES__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_SITE_STATIC_PAGES__REQUEST:
    case ACTION_LOAD_SITE_STATIC_PAGES__SUCCESS:
      return null;

    case ACTION_LOAD_SITE_STATIC_PAGES__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
